import { get } from "svelte/store";
import { queryCandidates } from "../api/dashboard";

import { getAllProjects } from "../api/projects";

import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getCampaigns } from "../api/campaigns";
import { dashboardSearchTerm } from "../src/pages/Dashboard/DashboardSearch/stores";

const dashboardCandidatesQueryPayload = () => {
  const searchTerm = get(dashboardSearchTerm);
  return {
    search: { value: searchTerm, regex: false },
    columns: [
      {
        name: "",
        search: { value: "", regex: false },
        data: "candidateId",
        searchable: true,
        orderable: false,
      },
    ],
    tagIds: [],
    start: 0,
    length: 50,
    stages: [],
    draw: 50,
    campaignIds: [],
    allTagsMustMatch: false,
    order: [{ column: 0, dir: "asc" }],
    sourcerUserIds: "",
    status: "",
  };
};

export const dashboardCandidatesQueryStore = SwApiStore({
  get: () => queryCandidates(dashboardCandidatesQueryPayload()),
  init: () => ({ data: [] }),
});

export const dashboardProjectsStore = SwApiStore({
  get: () => getAllProjects({ all: true }),
  init: () => [],
});

export const dashboardCampaignsStore = SwApiStore({
  get: () => getCampaigns({ openOnly: false, currentUserOnly: false }),
  init: () => [],
});
